import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

type BannerProps = {
  $bannerUrl: string | null;
  $primaryColor: string | null;
  $secondaryColor: string | null;
  $textColor: string | null;
};

export const Banner = styled.section<BannerProps>`
  position: relative;
  display: flex;
  align-items: center;
  min-height: 72px;
  padding: 10px 15px;
  border-radius: 16px;
  background-color: ${({ $primaryColor, theme }) =>
    $primaryColor ?? theme.palette.secondary.background};
  background-image: ${({ $bannerUrl, $primaryColor, $secondaryColor }) =>
    $bannerUrl
      ? `url("${$bannerUrl}")`
      : `linear-gradient(90deg, ${$primaryColor ?? 'transparent'} 0%, ${
          $secondaryColor ?? $primaryColor ?? 'transparent'
        } 100%)`};
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  color: ${({ $textColor, theme }) =>
    $textColor ?? theme.palette.primary.labels};
  overflow: hidden;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    min-height: 80px;
    padding: 15px 20px;
    border-radius: 14px;
    background-image: ${({ $primaryColor, $secondaryColor }) =>
      `linear-gradient(90deg, ${$primaryColor ?? 'transparent'} 0%, ${
        $secondaryColor ?? $primaryColor ?? 'transparent'
      } 100%)`};
  }
`;

export const Icon = styled.img`
  flex: 0 0 auto;
  width: 55px;
  height: 55px;
  margin-right: 10px;
  object-fit: contain;
`;

export const Content = styled.div`
  position: relative;
`;

export const Title = styled(Typography.Header)`
  font-weight: 700;
  font-size: 22px;
  color: inherit;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 16px;
  }
`;

export const Description = styled(Typography.Body).attrs({ $variant: '2' })`
  margin: 5px 0 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  color: inherit;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: -webkit-box;
    overflow: hidden;
    white-space: normal;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
`;

export const DetailsButton = styled.button`
  position: relative;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 44px;
  width: 170px;
  padding: 13px 15px;
  margin-left: auto;
  border: 0;
  font-size: 15px;
  border-radius: 14px;
  background-color: ${({ theme }) => theme.palette.system.white};
  color: ${({ theme }) => theme.palette.primary.labels};
  font-style: inherit;
  cursor: pointer;

  svg {
    display: none;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 0;
    background-color: rgb(255 255 255 / 30%);
    width: 35px;
    height: 35px;
    border-radius: 100px;

    svg {
      display: block;
      width: 24px;
      height: 24px;
      color: ${({ theme }) => theme.palette.system.white};
    }
  }
`;

export const DetailsButtonText = styled.span`
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }
`;

export const ModalTitle = styled(Typography.Title).attrs({ $variant: '4' })<{
  $textColor: string | null;
}>`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  min-width: 0;
  color: ${({ $textColor, theme }) =>
    $textColor ?? theme.palette.primary.labels};

  img {
    flex: 0 0 auto;
    width: 35px;
    height: 35px;
    object-fit: contain;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 0 55px 0 15px;
    font-size: 18px;
  }
`;

export const ModalTitleText = styled.span`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
